import React, { useState } from "react";
import { toast } from "react-toastify";
import useThemeColors from "../../vehicle/ThemeColors";
import { WORKSHOP_ID } from "../../../constants";
import { useCancelAppointmentMutation } from "../../../Services/inventory/Inventory";
import { useNavigate } from "react-router-dom";

interface IPROPS {
  closeModal: any;
  // refetch:any
  // requestedId:any
  storedWorkshopData: any;
}

const CancelAppointment: React.FC<IPROPS> = ({
  closeModal,
  storedWorkshopData,
}) => {
  console.log(storedWorkshopData, "scscccsdcsc");
  const [textArea, setTextArea] = useState("");

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);

  const [trigger, { status }] = useCancelAppointmentMutation();
  const navigate = useNavigate();

  const cancelServiceRequest = async (e) => {
    e.preventDefault();

    // const datePart = dayjs(selectedDate).format("YYYY-MM-DD");
    // const timePart = dayjs(selectedTime).format("HH:mm:ss");
    // const preferredTime = dayjs(selectedTime).format("HH:mm");

    // const bookingServicePayload = {
    //     "status": "cancelled",
    //     "service_reply": textArea ,// (optional) any note or reason for rescheduling
    //     user_id: getWorkshopId

    //     };

    const cancelAppointment = {
      id: storedWorkshopData?.appointment_id,
    };

    try {
      const response = await trigger(cancelAppointment);

      console.log(response, "sdcdscsdcsd");

      if (response?.data) {
        toast.success(response?.data?.message);
        // setIsCheckoutClicked(false)
        sessionStorage.clear();
        closeModal(true);
        navigate("/vehicle/appointment");
      }
    } catch (error) {
      toast.error("An error occured");
    }
  };

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <label
          style={{
            fontSize: "20px",
            fontWeight: "200",
            fontFamily: "Karbon-medium",
          }}
        >
          Cancel Appointment
        </label>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <label
          style={{ fontFamily: "Karbon", fontSize: "13px", color: "#333333" }}
        >
          Reason
        </label>
        <textarea
          onChange={(e) => setTextArea(e.target.value)}
          value={textArea}
          style={{ fontFamily: "karbon" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <button
          onClick={cancelServiceRequest}
          type="submit"
          style={{
            width: "100%",
            padding: "10px 25px",
            borderRadius: "20px",
            // background: `${selectedButtonBackgoundColors}`,
            // color: `${selectedButtonColors}`,
            // border: `1px solid ${selectedBorderColor}`,
            whiteSpace: "nowrap",
            background: `${selectedButtonBackgoundColors}`,
            color: `${selectedButtonColors}`,
            border: "none",
            // padding: "10px 20px",
            // borderRadius: "20px",
            fontSize: "13px",
            fontFamily: "Karbon-semi",
          }}
        >
          Cancel Service
        </button>
      </div>
    </div>
  );
};

export default CancelAppointment;
